import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import Testimonials from '../components/Testimonials';
import '../styles/HomePage.css';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="home-page-premium">
      {/* Hero Section - Ultra Clean */}
      <section className="hero-premium">
        <div className="container-premium">
          <div className="hero-content-premium">
            <div className="hero-badge">
              <span>Entreprise d'entretien paysager en Estrie</span>
            </div>
            <h1 className="hero-title-premium">
              Votre gazon, <span className="highlight-lime italic-text">naturellement vert</span>
            </h1>
            <p className="hero-description-premium">
              Des solutions naturelles et professionnelles pour transformer votre espace extérieur.
              Fertilisation naturelle, contrôle des mauvaises herbes et taille de haies.
            </p>
            <div className="hero-actions-premium">
              <button className="btn-primary-premium" onClick={() => navigate('/contact')}>
                Demander une soumission
                <ArrowRight size={20} strokeWidth={2.5} />
              </button>
              <a href="tel:4502101858" className="btn-secondary-premium">
                450 210 1858
              </a>
            </div>
            
            {/* Trust badges */}
            <div className="trust-badges-premium">
              <div className="trust-item-premium">
                <Check size={16} strokeWidth={3} />
                <span>100% Naturel</span>
              </div>
              <div className="trust-item-premium">
                <Check size={16} strokeWidth={3} />
                <span>Service rapide</span>
              </div>
              <div className="trust-item-premium">
                <Check size={16} strokeWidth={3} />
                <span>Satisfaction garantie</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section - Minimal Cards */}
      <section className="services-premium">
        <div className="container-premium">
          <div className="section-header-premium">
            <span className="section-label">Services</span>
            <h2 className="section-title-premium">Ce que nous faisons de mieux</h2>
          </div>

          <div className="services-grid-premium">
            <div className="service-card-premium">
              <div className="service-number">01</div>
              <h3 className="service-title-premium">Fertilisation naturelle</h3>
              <p className="service-desc-premium">
                Programme complet de fertilisation 100% naturelle pour une pelouse dense, verte et en santé toute la saison.
              </p>
              <button className="service-link-premium" onClick={() => navigate('/services')}>
                En savoir plus
                <ArrowRight size={16} />
              </button>
            </div>

            <div className="service-card-premium">
              <div className="service-number">02</div>
              <h3 className="service-title-premium">Contrôle des mauvaises herbes</h3>
              <p className="service-desc-premium">
                Élimination efficace et naturelle des mauvaises herbes sans compromettre la santé de votre pelouse.
              </p>
              <button className="service-link-premium" onClick={() => navigate('/services')}>
                En savoir plus
                <ArrowRight size={16} />
              </button>
            </div>

            <div className="service-card-premium">
              <div className="service-number">03</div>
              <h3 className="service-title-premium">Taille de haies</h3>
              <p className="service-desc-premium">
                Service professionnel de taille pour des haies parfaitement entretenues et un aménagement impeccable.
              </p>
              <button className="service-link-premium" onClick={() => navigate('/services')}>
                En savoir plus
                <ArrowRight size={16} />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <Testimonials />

      {/* CTA Section - Minimal */}
      <section className="cta-premium">
        <div className="container-premium">
          <div className="cta-content-premium">
            <h2 className="cta-title-premium">
              Prêt à transformer votre espace extérieur?
            </h2>
            <p className="cta-description-premium">
              Obtenez une soumission gratuite en moins de 24 heures.
            </p>
            <button className="btn-primary-premium" onClick={() => navigate('/contact')}>
              Commencer maintenant
              <ArrowRight size={20} strokeWidth={2.5} />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
